import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  firstName: Yup.string().nullable().required('First Name is required'),
  lastName: Yup.string().nullable().required('Last Name is required'),
  gender: Yup.string().nullable().required('Gender is required'),
  dateOfBirth: Yup.string().nullable().required('Date of Birth is required'),
  licenseNumber: Yup.string().nullable().required('License Number is required'),
  licenseState: Yup.string().nullable().required('License State is required'),
  licenseType: Yup.string().nullable().required('License Type is required'),
  address1: Yup.string().nullable().required('Address 1 is required'),
  phoneNumber: Yup.string().nullable().required('Phone Number is required'),
  city: Yup.string().nullable().required('City is required'),
  state: Yup.string().nullable().required('State is required'),
  zip: Yup.string().nullable().required('Zip is required'),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
